import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { useForm } from 'react-hook-form';
import { CoreContext } from './context/index.js';
import logger from './utils/logger.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import { M as MD_WIDTH } from './breakpoints-X1SKRYyW.js';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import useCaptcha from './hooks/useCaptcha.js';
import './index-zNO-4REJ.js';
import 'next/router';
import useShowError from './hooks/useShowError.js';
import useShowNotify from './hooks/useShowNotify.js';
import useWindowSize from './hooks/useWindowSize.js';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import { validateHCaptchaTokenOnServer } from './utils/captcha.js';
import { extractErrorMessage } from './utils/error.js';
import { getValidationSchema, initialValues } from './components/Help/ContactUs/ContactUsForm/form/index.js';
import Button from './components/Button/index.js';
import ButtonGroup from './components/ButtonGroup/index.js';
import { I as Input } from './Input-quQLghm0.js';
import { T as Textarea } from './Textarea-CrVLRrCI.js';
import { S as SelectComponent } from './Select-LSn3KQwG.js';
import { H as HCaptchaComponent } from './HCaptcha-z_AMrNS9.js';
import { w as withProviders } from './withProviders-l3mjYkR2.js';
import { G as GetHCaptchaToken } from './GetHCaptchaToken-sJpm0bg0.js';
import { ContactUsFormSubmit } from './services/graphql/help/index.js';
import { e as usePublicMutation } from './requestsCollection-gritD79O.js';

const subjectOptions = ['label', 'help', 'returns', 'feedback', 'information', 'other'];
const subjectOptionsAccor = [
    'label',
    'help',
    'returns',
    'feedback',
    'information',
    'rewards',
    'other',
];

const ContactUsForm = () => {
    var _a;
    const { t: tValidation } = useTranslation('', { keyPrefix: '$common.$validation' });
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { t: tContact } = useTranslation('', { keyPrefix: '$common.$labels.$contactOptions' });
    const { t: tContactAccor } = useTranslation('', {
        keyPrefix: '$accorCommon.$labels.$contactOptions',
    });
    // const { t: tHeading } = useTranslation('', { keyPrefix: '$common.$headings' });
    const { apolloConfig, data: { siteConfig: { contactUs: { labelVariant = 'inline' } = {}, enableAccorAllNumber = false }, }, } = useContext(CoreContext);
    const windowSize = useWindowSize();
    const isSmallScreen = Boolean(windowSize.width) && windowSize.width <= MD_WIDTH;
    const variant = !isSmallScreen ? labelVariant : 'stacked';
    const { isFulfilled: isCaptchaFulfilled, captcha } = useCaptcha();
    const showCaptcha = isCaptchaFulfilled && captcha.contact_us;
    const captchaSiteKey = captcha.public_key;
    const { register, handleSubmit, clearErrors, setValue, reset, setError, formState: { errors }, } = useForm({
        resolver: getValidationSchema(showCaptcha),
        defaultValues: initialValues,
        mode: 'onSubmit',
    });
    const [sendMessage, { loading }] = usePublicMutation(apolloConfig(), ContactUsFormSubmit);
    const showErrorNotify = useShowError();
    const showSuccessNotify = useShowNotify();
    const selectedSubjectOptions = enableAccorAllNumber ? subjectOptionsAccor : subjectOptions;
    const tSelectedContact = enableAccorAllNumber ? tContactAccor : tContact;
    const subjectOptionsTranslated = selectedSubjectOptions.map(option => ({
        value: option === 'label' ? '' : tSelectedContact(option),
        label: tSelectedContact(option),
    }));
    const handleCaptchaVerify = async (token) => {
        const success = await validateHCaptchaTokenOnServer(apolloConfig, token, GetHCaptchaToken);
        if (success) {
            setValue('captcha', token);
            clearErrors('captcha');
        }
        else {
            setValue('captcha', null);
            // TODO: add translation
            setError('captcha', { message: 'Captcha token is invalid' });
        }
    };
    const handleCaptchaExpire = () => {
        setValue('captcha', null);
        setError('captcha', { message: tValidation('captchaExpired') });
    };
    const onSubmit = async ({ captcha: _, ...values }) => {
        try {
            const responseStatus = await sendMessage({
                variables: values,
            }).then(res => res.data.contactusFormSubmit.response_message);
            if (responseStatus === 'Succeed' || responseStatus === 'Succeed (french)') {
                showSuccessNotify(tValidation('contactUsPostedTips'));
                reset();
            }
            else {
                logger('Server error: unable to send message.', { type: 'error', sendLog: true });
                showErrorNotify(tValidation('serverError'));
            }
        }
        catch (e) {
            showErrorNotify(extractErrorMessage(e));
        }
    };
    return (React.createElement("form", { className: "contact-us-form", onSubmit: handleSubmit(onSubmit) },
        React.createElement("fieldset", null,
            React.createElement("div", { className: "contact-us-form__field" },
                React.createElement(Input, { variant: variant, name: "firstname", id: "contact-input-firstname", register: register, errors: errors, label: `${tLabel('firstName')}*` })),
            React.createElement("div", { className: "contact-us-form__field" },
                React.createElement(Input, { variant: variant, name: "lastname", id: "contact-input-lastname", register: register, errors: errors, label: `${tLabel('lastName')}*` })),
            React.createElement("div", { className: "contact-us-form__field" },
                React.createElement(Input, { variant: variant, name: "email", id: "contact-input-email", autocomplete: "email", register: register, errors: errors, label: `${tLabel('emailAddr')}*`, inputMode: "email" })),
            React.createElement("div", { className: "contact-us-form__field" },
                React.createElement(Input, { variant: variant, name: "telephone", id: "contact-input-telephone", register: register, errors: errors, label: `${tLabel('telephone')}*`, inputMode: "tel", type: "tel" })),
            React.createElement("div", { className: "contact-us-form__field" },
                React.createElement(SelectComponent, { variant: variant, name: "subject", id: "subject", register: register, options: subjectOptionsTranslated, errors: errors, placeholder: tSelectedContact('label'), label: `${tLabel('subject')}*`, ariaLabel: `${tLabel('subject')}*` })),
            React.createElement("div", { className: "contact-us-form__field" },
                React.createElement(Textarea, { variant: variant, name: "message", register: register, errors: errors, label: `${tLabel('message')}*` })),
            showCaptcha && (React.createElement(HCaptchaComponent, { siteKey: captchaSiteKey, error: (_a = errors.captcha) === null || _a === void 0 ? void 0 : _a.message, onVerify: handleCaptchaVerify, onExpire: handleCaptchaExpire })),
            React.createElement("div", { className: "contact-us-form__note" },
                "*",
                tLabel('requiredFields')),
            React.createElement("div", { className: "spacer" }),
            React.createElement(ButtonGroup, { align: "left", vertical: "never" },
                React.createElement(Button, { type: "submit", className: "contact-us-form-btn", isLoading: loading, variant: "black" }, tButton('submit'))))));
};
var ContactUsForm$1 = withProviders(ContactUsForm, { translation: true, snackbar: true });

export { ContactUsForm$1 as C };
//# sourceMappingURL=ContactUsForm-EJ9jibi5.js.map
